import type {ReactNode} from 'react'

interface WizardStepHeadingProps {
    title: ReactNode
    description?: ReactNode
    'data-testid'?: string
}

export function WizardStepHeading({title, description, 'data-testid': testId}: WizardStepHeadingProps) {
    return (
        <div className="mb-4" data-testid={testId}>
            <h3 className="text-lg font-semibold" data-testid={testId ? `${testId}-title` : 'wizard-step-heading-title'}>{title}</h3>
            {description && <p className="text-sm text-muted-foreground">{description}</p>}
        </div>
    )
}
